import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import swal from 'sweetalert';
import { UserDashboardLayout } from '../../../layouts/UserDashboardLayout';
import { changePassword } from '../../../services/AuthService';

export function ChangePassword() {
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
    });
    const [errors, setErrors] = useState({});

    const validateForm = () => {
        const newErrors = {};

        if (!formData.oldPassword) {
            newErrors.oldPassword = 'La contraseña anterior es requerida';
        }
        if (!formData.newPassword) {
            newErrors.newPassword = 'La nueva contraseña es requerida';
        }
        if (!formData.confirmPassword) {
            newErrors.confirmPassword = 'La confirmación de contraseña es requerida';
        }
        if (formData.newPassword && formData.newPassword.length < 6) {
            newErrors.newPassword = 'La contraseña debe tener al menos 6 caracteres';
        }
        if (formData.newPassword !== formData.confirmPassword) {
            newErrors.confirmPassword = 'Las contraseñas no coinciden';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        setLoading(true);
        try {
            await changePassword(formData);

            swal('¡Éxito!', 'Contraseña actualizada correctamente', 'success');
            setFormData({
                oldPassword: '',
                newPassword: '',
                confirmPassword: ''
            });
            history.push('/profile');
        } catch (error) {
            const errorMessage = error?.response?.data?.message || error?.message || 'Error al actualizar la contraseña';
            swal('Error', errorMessage, 'error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <UserDashboardLayout>
            <div className="job-bx job-profile">
                <div className="job-bx-title clearfix">
                    <h5 className="font-weight-700 pull-left text-uppercase">Cambiar Contraseña</h5>
                    <button
                        type="button"
                        onClick={() => history.goBack()}
                        className="site-button right-arrow button-sm float-right"
                    >
                        Atrás
                    </button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="form-group">
                                <label>Contraseña Anterior</label>
                                <input
                                    type="password"
                                    className={`form-control ${errors.oldPassword ? 'is-invalid' : ''}`}
                                    name="oldPassword"
                                    value={formData.oldPassword}
                                    onChange={handleChange}
                                />
                                {errors.oldPassword && <small className="text-danger">{errors.oldPassword}</small>}
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="form-group">
                                <label>Nueva Contraseña</label>
                                <input
                                    type="password"
                                    className={`form-control ${errors.newPassword ? 'is-invalid' : ''}`}
                                    name="newPassword"
                                    value={formData.newPassword}
                                    onChange={handleChange}
                                />
                                {errors.newPassword && <small className="text-danger">{errors.newPassword}</small>}
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="form-group">
                                <label>Confirmar Nueva Contraseña</label>
                                <input
                                    type="password"
                                    className={`form-control ${errors.confirmPassword ? 'is-invalid' : ''}`}
                                    name="confirmPassword"
                                    value={formData.confirmPassword}
                                    onChange={handleChange}
                                />
                                {errors.confirmPassword && <small className="text-danger">{errors.confirmPassword}</small>}
                            </div>
                        </div>
                        <div className="col-lg-12 m-b10">
                            <button
                                type="submit"
                                className="site-button"
                                disabled={loading}
                            >
                                {loading ? 'Actualizando...' : 'Actualizar Contraseña'}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </UserDashboardLayout>
    );
}
